import React, { Component } from 'react';
import { Button, Col, Collapse, Row } from 'reactstrap';
import Api from '../Api';
import CaretToggle from '../Icons/CaretToggle';
import HtmlHelpers from '../HtmlHelpers';
import ListFunctions from '../FunctionsList';
import ModalConfirmation from '../Modals/Confirmation';
import WmReactTable from '../Layout/WmReactTable';
import AddForm from './AddForm';
import EditForm from './EditForm';
import Columns from './Columns';
export default class Attachments extends Component {
  constructor(props) {
    super(props);
    this.addButtonType = () => '';
    this.title = () => 'Attachments';
    this.modelType = () => this.props.modelType;
    this.modelUuid = () => this.props.modelUuid;
    this.storageName = () => '';
    this.hideBottomHr = () => true;
    this.addAdmin = () => this.props.isAddAdmin === true;
    this.queryParams = () => "model_type = '".concat(this.modelType(), "' and model_uuid = '").concat(this.modelUuid(), "'");
    this.modifyData = data => data;
    this.getColumns = () => this.columnsBefore().concat(Columns.getBaseColumns(this)).concat(this.columnsAfter());
    this.columnsBefore = () => [];
    this.columnsAfter = () => [];
    this.updateState = data => this.setState(data);
    this.updateData = () => {
      this.closeModals();
      this.getData();
    };
    this.closeOnZero = () => this.setState(prevState => prevState.data.size === 0 ? {
      notesShowing: false
    } : {
      notesShowing: true
    });
    this.getData = async () => {
      const apiOptions = {
        auth: this.props.auth,
        listApi: "attachments?query=".concat(this.queryParams())
      };
      const data = await ListFunctions.fetchData(apiOptions);
      const modifiedData = this.modifyData(data.data);
      this.setState({
        data: modifiedData,
        AttachmentPages: data.pages,
        loading: false,
        attachmentOpen: modifiedData.length > 0
      });
    };
    this.addForm = () => !this.state.attachmentAddModal ? '' : /*#__PURE__*/React.createElement(AddForm, {
      auth: this.props.auth,
      modelType: this.modelType(),
      modelUuid: this.modelUuid(),
      title: "".concat(this.addButtonType(), " Attachment"),
      showModal: this.state.attachmentAddModal,
      closeModal: this.closeModals,
      updateData: this.updateData
    });
    this.editForm = () => !this.state.attachmentEditModal ? '' : /*#__PURE__*/React.createElement(EditForm, {
      auth: this.props.auth,
      data: this.state.data,
      editItem: this.state.editItem,
      title: "Attachment",
      showModal: this.state.attachmentEditModal,
      closeModal: this.closeModals,
      updateData: this.updateData
    });
    this.deleteConfirmation = () => {
      let contents = '';
      if (this.state.attachmentDeleteModal) {
        contents = /*#__PURE__*/React.createElement(ModalConfirmation, {
          msg: "Are you sure you want to delete this attachment?",
          onConfirmation: this.sumbitDelete,
          showModal: this.state.attachmentDeleteModal,
          closeModal: this.closeModals
        });
      }
      return contents;
    };
    this.sumbitDelete = () => {
      const uuid = this.state.data[this.state.editItem].uuid;
      Api.crudDelete(this.props.auth, 'attachments', {
        uuid
      }).then(response => {
        if (response.data !== undefined) {
          const newData = Object.assign([], this.state.data);
          newData[this.state.editItem] = response.data.attributes;
          this.setState({
            data: newData
          });
          this.props.alert.show('Attachment removed Successfully', {
            type: 'success'
          });
        } else if (response.errors !== undefined) {
          const errors = HtmlHelpers.convertRailsErrors(response.errors);
          this.props.alert.show(errors.join(', '), {
            type: 'error'
          });
        } else {
          this.props.alert.show('System error, please try again. If you continue to get this error, open a Help Desk ticket', {
            type: 'error'
          });
        }
      }).then(() => this.closeModals());
    };
    this.openAddAttachment = () => this.setState({
      attachmentOpen: true,
      attachmentAddModal: true
    });
    this.selectItem = index => this.setState({
      attachmentEditModal: true,
      editItem: index
    });
    this.deleteItem = index => this.setState({
      attachmentDeleteModal: true,
      editItem: index
    });
    this.closeModals = () => this.setState({
      attachmentAddModal: false,
      attachmentEditModal: false,
      attachmentDeleteModal: false,
      editItem: -1
    });
    this.addButton = () => this.addAdmin() ? /*#__PURE__*/React.createElement(Button, {
      outline: true,
      className: "btn-sm",
      color: "info",
      onClick: this.openAddAttachment
    }, "Add ".concat(this.addButtonType(), " Attachment")) : '';
    this.showToggle = () => this.setState(prevState => ({
      attachmentsShowing: !prevState.attachmentsShowing
    }));
    this.attachmentsTable = () => /*#__PURE__*/React.createElement(Collapse, {
      isOpen: true
    }, /*#__PURE__*/React.createElement(WmReactTable, {
      data: this.state.data,
      loading: this.state.loading,
      columns: this.getColumns(),
      className: "otto__short_table",
      getTrProps: (state, rowInfo, instance) => !rowInfo || HtmlHelpers.isEmpty(rowInfo.original.deleted_at) ? {} : {
        style: {
          textDecoration: 'line-through',
          color: '#999'
        }
      }
    }));
    this.getTable = () => /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      md: "6",
      xs: "12"
    }, /*#__PURE__*/React.createElement("h4", null, "".concat(this.title(), " (").concat(this.state.loading ? 'loading' : this.state.data.length, ")"), "\xA0\xA0\xA0", /*#__PURE__*/React.createElement(CaretToggle, {
      open: this.state.attachmentsShowing,
      onClick: this.showToggle
    }))), /*#__PURE__*/React.createElement(Col, {
      md: "6",
      xs: "12",
      className: "text-right"
    }, this.addButton())), this.hideBottomHr() ? '' : /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(Collapse, {
      isOpen: this.state.attachmentsShowing
    }, this.attachmentsTable()));
    this.titleClass = () => '';
    this.getLink = () => /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
      className: this.titleClass
    }, "".concat(this.title(), " (").concat(this.state.loading ? 'loading' : this.state.data.length, ")")), "\xA0\xA0\xA0", /*#__PURE__*/React.createElement(CaretToggle, {
      className: "otto__no_padding",
      open: this.state.attachmentsShowing,
      onClick: this.showToggle
    }), /*#__PURE__*/React.createElement(Collapse, {
      isOpen: this.state.attachmentsShowing
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      md: "12",
      xs: "12",
      className: "text-right"
    }, this.addButton())), this.attachmentsTable()));
    this.renderType = () => this.getTable();
    this.render = () => /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("br", null), this.renderType(), this.addForm(), this.editForm(), this.deleteConfirmation());
    this.state = {
      attachmentOpen: false,
      loading: true,
      attachmentAddModal: false,
      attachmentEditModal: false,
      attachmentDeleteModal: false,
      attachmentsShowing: false,
      data: []
    };
    this.getData();
  }
}